import { SessionChatOpenCloseConversation } from 'shared/components/SessionChatAfterFooter/SessionChatOpenCloseConversation';
import React from 'react';
import { useAppSelector } from 'shared/store';
import { ConversationAssignButton } from './ConversationAssignButton';
import './style.less';

interface Props {
  openConversation?: (visitorId: string, conversationId: number) => void;
}

export const SessionChatAfterFooter: React.FC<Props> = ({ openConversation }) => {
  const { conversation } = useAppSelector(s => s.conversation);

  return (
    <div className="SessionChatAfterFooter">
      <ConversationAssignButton conversation={conversation} />
      <SessionChatOpenCloseConversation
        conversation={conversation}
        openConversation={openConversation}
      />
    </div>
  );
};
